import { DATA_SOURCE_TYPE } from '../../constants';

const { CCD, DEVICES } = DATA_SOURCE_TYPE;

export const BUTTONS = [
  {
    type: DEVICES,
    color: '#326cba',
  },
  {
    type: CCD,
    color: '#f87f5c',
  },
];



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/Chart/Legend/buttons.js